import React from "react";
import { Link, NavLink } from "react-router-dom";
import { LOGO_URL } from "../lib/config";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/atelier", label: "L'Atelier" },
  { to: "/professionnels", label: "Professionnels" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-[#171717]/90 backdrop-blur-xl border-b border-[#9A8640]/20 py-3" : "bg-transparent py-5"}`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Passion Verre" className={`object-contain transition-all duration-500 ${scrolled ? "h-14 w-14" : "h-20 w-20 sm:h-24 sm:w-24"}`} />
          <span className="hidden sm:block font-serif text-2xl tracking-wide text-[#DDD4B2]">Passion Verre</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.18em] transition-colors ${isActive ? "text-[#9A8640]" : "text-[#DDD4B2]/80 hover:text-[#9A8640]"}`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-gold px-5 py-2 text-xs uppercase" data-testid="nav-cta-contact">
            Demander un devis
          </Link>
        </nav>
        <button
          className="lg:hidden text-[#DDD4B2] p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#171717] border-t border-[#9A8640]/20" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.18em] ${isActive ? "text-[#9A8640]" : "text-[#DDD4B2]"}`
                }
                end={item.to === "/"}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-gold px-5 py-2 text-xs uppercase text-center mt-2">
              Demander un devis
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
